import React from 'react';
import Head from 'next/head';
import { JsonLd } from 'components/JsonLd';
import { HeadSection } from 'components/HeadSection';
import { useProductDetailState } from 'contexts';
import { useTenantConfig } from 'hooks';

export const MetaData: React.FC = () => {
  const { product, primitiveProduct, productHelper } = useProductDetailState();
  const { baseDomain } = useTenantConfig();

  const data = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: primitiveProduct?.productInfo?.name,
    image: primitiveProduct?.productInfo?.imageUrl,
    brand: {
      '@type': 'Brand',
      name: primitiveProduct?.productInfo?.brand?.name,
    },
    offers: {
      '@type': 'Offer',
      price: primitiveProduct?.prices?.[0]?.latestPrice,
    },
    url: `${baseDomain}${productHelper.getLinkProduct(primitiveProduct)}`,
    description: primitiveProduct?.productDetail?.seoInfo?.metaDescription,
    sku: primitiveProduct?.productInfo?.sku,
    category: primitiveProduct?.productInfo.categories?.[0]?.name,
  };

  return (
    <>
      <Head>
        {baseDomain && primitiveProduct && (
          <link
            rel="canonical"
            href={`${baseDomain}${productHelper.getLinkProduct(
              primitiveProduct,
            )}`}
          />
        )}
      </Head>
      {/*Đánh dấu JSON-LD*/}
      <JsonLd data={data} />
      <HeadSection
        title={product?.seoInfo?.metaTitle}
        description={product?.seoInfo?.metaDescription}
        keywords={product?.seoInfo?.metaKeyword}
        image={product?.images?.[0]?.src}
      />
    </>
  );
};
